
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useLanguage } from "@/contexts/LanguageContext";
import { Calendar } from "lucide-react";
import WaitlistForm from "../WaitlistForm";

const BetaHero = () => {
  const { language } = useLanguage();

  const content = {
    fr: {
      badge: "Phase de test",
      title: "Révolutionnez la transmission émotionnelle et financière",
      subtitle: "Une nouvelle façon de créer des liens intergénérationnels durables",
      description: "Rejoignez les premiers utilisateurs qui transforment la manière dont nous créons des connexions significatives à travers le temps.",
      stats: [
        { number: "94%", label: "Satisfaction beta" },
        { number: "150+", label: "Utilisateurs test" },
        { number: "3.2M", label: "CHF engagés" }
      ]
    },
    en: {
      badge: "Testing Phase",
      title: "Revolutionize emotional and financial legacy",
      subtitle: "A new way to create lasting intergenerational bonds",
      description: "Join the first users transforming how we create meaningful connections across time.",
      stats: [
        { number: "94%", label: "Beta satisfaction" },
        { number: "150+", label: "Test users" },
        { number: "3.2M", label: "CHF committed" }
      ]
    },
    de: {
      badge: "Testphase",
      title: "Revolutionieren Sie das emotionale und finanzielle Vermächtnis",
      subtitle: "Eine neue Art, dauerhafte generationenübergreifende Verbindungen zu schaffen",
      description: "Schließen Sie sich den ersten Nutzern an, die die Art und Weise verändern, wie wir bedeutungsvolle Verbindungen über die Zeit hinweg schaffen.",
      stats: [
        { number: "94%", label: "Beta-Zufriedenheit" },
        { number: "150+", label: "Testnutzer" },
        { number: "3.2M", label: "CHF zugesagt" }
      ]
    }
  };

  return (
    <section className="pt-32 pb-20 md:pt-40 md:pb-24 px-4 bg-gradient-to-br from-legatia-light to-white overflow-hidden relative">
      <div className="absolute top-20 right-[10%] w-64 h-64 bg-legatia-orange/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 left-[5%] w-40 h-40 bg-legatia-yellow/20 rounded-full blur-2xl"></div>
      
      <div className="container mx-auto relative z-10">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <Badge variant="outline" className="mb-6 text-legatia-orange border-legatia-orange">
            {content[language].badge}
          </Badge>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight animate-fade-in">
            {content[language].title}
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-700 mb-8 animate-fade-in" style={{ animationDelay: "0.2s" }}>
            {content[language].subtitle}
          </p>
          
          <p className="text-lg text-gray-600 mb-12 animate-fade-in" style={{ animationDelay: "0.3s" }}>
            {content[language].description}
          </p>
          
          <div className="grid grid-cols-3 gap-8 mb-12">
            {content[language].stats.map((stat, index) => (
              <div key={index} className="bg-white/80 p-4 rounded-lg shadow-sm">
                <div className="text-2xl font-bold text-legatia-orange">{stat.number}</div>
                <div className="text-sm text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
          
          <div className="max-w-md mx-auto">
            <WaitlistForm buttonLabel={language === 'fr' ? "Rejoindre les premiers testeurs" : language === 'en' ? "Join early testers" : "Werden Sie Frühtester"} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BetaHero;
